/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';

const Placeholder = ({ styles }) => (
  <a className={styles.eventRow} data-hook="search-result-placeholder">
    <div className={styles.sportIconPlaceholder}>
      <span />
    </div>
    <div className={styles.eventInfoPlaceholder}>
      <p />
      <span />
    </div>
    <div className={styles.eventTimePlaceholder}>
      <span />
    </div>
  </a>
);

Placeholder.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default Placeholder;
